import { render, staticRenderFns } from "./DesktopAdFreestar.vue?vue&type=template&id=6f4862eb&scoped=true"
import script from "./DesktopAdFreestar.vue?vue&type=script&lang=js"
export * from "./DesktopAdFreestar.vue?vue&type=script&lang=js"
import style0 from "./DesktopAdFreestar.vue?vue&type=style&index=0&id=6f4862eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4862eb",
  null
  
)

export default component.exports